export const ITEM_CATEGORIES = [
  { id: "produce", name: "Produce" },
  { id: "meat_poultry", name: "Meat & Poultry" },
  { id: "fish_seafood", name: "Fish & Seafood" },
  { id: "dairy_eggs", name: "Dairy & Eggs" },
  { id: "bakery", name: "Bakery" },
  { id: "pantry_staples", name: "Pantry Staples" },
  { id: "snacks", name: "Snacks" },
  { id: "beverages", name: "Beverages" },
  { id: "frozen_foods", name: "Frozen Foods" },
  { id: "household", name: "Household" },
  { id: "personal_care", name: "Personal Care" },
  { id: "alcohol", name: "Alcohol" },
  { id: "fuel", name: "Fuel" },
  { id: "other", name: "Other" }
];

export const FUEL_GRADES = [
  { id: "E10", name: "E10 (standard unleaded)" },
  { id: "E5", name: "E5 (premium unleaded)" },
  { id: "other", name: "Other / unknown" },
];
